module.exports = __webpack_public_path__ + "0384eb8ba6eff5b1cbbc73b8d52d2ef7.pdf";